import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {StoredSearchServiceImplementation} from '../../stored-search.service';
import {StoredSearch} from '../../../core/definitions/stored-search';

export interface StoredSearchEditDialogData {
  fsi: StoredSearchServiceImplementation;
  storedSearchNameQuery: string;
  originalStoredSearch: boolean;
  storedSearchInEdit: StoredSearch;
}

@Component({
    selector: 'app-search-stored-search-edit-dialog',
    templateUrl: './stored-search-edit-dialog.component.html',
    styleUrls: ['./stored-search-edit-dialog.component.scss'],
    standalone: false
})
export class StoredSearchEditDialogComponent {
  // Injections
  public dialogRef: MatDialogRef<StoredSearchEditDialogComponent> = inject(MatDialogRef);
  public data: StoredSearchEditDialogData = inject(MAT_DIALOG_DATA);

  validateError = null;

  clearNameInput() {
    this.data.storedSearchNameQuery = '';
  }

  validateCurrentAndAddNewName() {
    let res = false;
    const query = this.data.storedSearchNameQuery;
    if (query !== undefined && query !== '') {
      const storedSearches = this.getStoredSearches();
      for (let t = 0; t < storedSearches.length; t++) {
        const f = storedSearches[t];
        if (this.data.storedSearchInEdit.stored_search.name !== query.trim() && f.stored_search.name.trim() === query.trim()) {
          this.validateError = 'TRANS__FOCUS__EDIT__VALIDATE__NAME_EXISTS';
          res = true;
          break;
        }
      }
      if (this.data.storedSearchInEdit.stored_search.name === query.trim() &&
        this.data.originalStoredSearch === this.data.storedSearchInEdit.stored_search.isDefault) {
        res = true;
        this.validateError = null;
      }
    } else {
      this.validateError = 'TRANS__FOCUS__EDIT__VALIDATE__NO_NAME';
      res = true;
    }
    return res;
  }

  toggleIsDefault(fo) {
    this.data.fsi.toggleStoredSearchIsDefault(fo);
  }

  saveStoredSearch() {
    this.dialogRef.close(this.data.storedSearchNameQuery);
  }

  private getStoredSearches(): StoredSearch[] {
    return this.data.fsi.getStoredSearches();
  }
}
